import { useRef, useState } from "react";
import LeftArrowTopHeader from "../../newComponents/form-fields/LeftArrowTopHeader";
import SimpleButton from "../../newComponents/buttons/Simple-button";
import ShowLeaseAgreement from "../tenants/LeaseAgreement/ShowLeaseAgreement";
import { handleDownloadPdf } from "../../utils/validateHelper";
import EmptyState from "../../newComponents/emptystate";
import { GetImages } from "../../utils/GetImages";

interface LeaseAgreementProps {
  tenantData?: any;
  path?: string;
}

const LeaseAgreement = ({ tenantData, path=undefined }: LeaseAgreementProps) => {
  const contentRef = useRef(null);
  const [isPrint, setIsPrint] = useState(false);

  const handleDownload = () => {
    const fileName = `LeaseAgreement-${tenantData?.currentLeaseAgreementId}.pdf`;
    handleDownloadPdf(setIsPrint, contentRef, fileName);
  };

  const backPath = path || "/";

  return (
    <div>
      {tenantData?.usedLeaseAgreementTemplate && (
        <>
          <div className="top-listing-header-top">
            <LeftArrowTopHeader title="Lease Agreement" backPath={backPath} />
            <SimpleButton
              label={"Download Agreement"}
              onClick={handleDownload}
            />
          </div>

          {/* WRAP CONTENT IN REF → IMPORTANT FOR PDF */}
          <div ref={contentRef}>
            <ShowLeaseAgreement
              leaseApplicationId={undefined}
              currentLeaseAgreementId={tenantData?.currentLeaseAgreementId}
              isPreview={false}
              userData={tenantData}
              selectedTemplateid={1}
              postLeaseAgreement={1}
              setPostLeaseAgreement={1}
              onClick={() => {}}
              onCancel={
                () => undefined
                //  setPreviewLeaseAgreement(false)
              }
              role="tenant"
              buttonName=""
              selectedTemplates={undefined}
              showHeader={false}
              readCurrentAgreemnet={true}
            />
          </div>
        </>
      )}

      {!tenantData?.usedLeaseAgreementTemplate &&
        !tenantData?.currentLeaseAgreementDocumentId && (
          <div className="lease-download-container">
            {/* Top Center Header */}
            <div className="lease-header-center">
              <LeftArrowTopHeader title="Lease Agreement" backPath={"/"} />
            </div>
            <div className="no-lease-agreement">
              <EmptyState
                icon={GetImages.leaseAgreementAvatar}
                className="bg-transparent"
                isBorder={false}
                heading="No Lease Agreement Found"
                isButton={false}
              />
            </div>
          </div>
        )}
    </div>
  );
};

export default LeaseAgreement;
